exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody .v-modal {\r\n  background-color: rgba(0, 0, 0, 0.1);\n}\r\n", ""]);

// exports
